import styled from '@mint-lib/styled';

import Box from '../../Box/Box.jsx';
import Button, { ButtonProps } from '../../Button/Button.jsx';
import IconButton from '../../IconButton/IconButton.jsx';
import Typography from '../../Typography/Typography.jsx';
import {
  colorByProcessingStatus,
  processingStatusElements,
} from '../helpers.jsx';

export interface BtnProps extends ButtonProps {
  label?: string;
}

export interface ProcessingModalHeaderProps {
  isAccordionOpened?: boolean;
  processingStatus: 'default' | 'error' | 'success';
  onExpandButtonClick?: () => void;
  onCloseButtonClick?: () => void;
  isModalExpanded?: boolean;
  additionalActions?: BtnProps[] | null;
  headerTitle?: string;
}

const ProcessingModalHeader = ({
  processingStatus,
  onExpandButtonClick,
  isModalExpanded,
  onCloseButtonClick,
  additionalActions,
  headerTitle,
}: ProcessingModalHeaderProps) => {
  return (
    <Root>
      <ProcessingTopBar $processingStatus={processingStatus}>
        <ProcessingTopBarLeftSide>
          <IconButton
            aria-label="expand-button"
            color={processingStatus === 'error' ? 'error' : 'primary'}
            variant="icon"
            size="small"
            icon={isModalExpanded ? 'ChevronDown' : 'ChevronRight'}
            onClick={onExpandButtonClick}
          />
          {processingStatusElements[processingStatus]()}
          <Typography
            variant="bodyShort02"
            color={colorByProcessingStatus[processingStatus].text}
          >
            {headerTitle}
          </Typography>
        </ProcessingTopBarLeftSide>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Box>
            {additionalActions?.map(({ label, ...rest }) => (
              <Button size="large" key={label} {...rest}>
                {label}
              </Button>
            ))}
          </Box>
          <IconButton
            aria-label="close-button"
            color={processingStatus === 'error' ? 'error' : 'primary'}
            variant="icon"
            size="small"
            icon="Close"
            onClick={onCloseButtonClick}
          />
        </Box>
      </ProcessingTopBar>
    </Root>
  );
};

export default ProcessingModalHeader;

const Root = styled(Box)`
  width: 25rem;
`;

const ProcessingTopBar = styled(Box)<{
  $processingStatus: 'default' | 'error' | 'success';
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  height: 2.5rem;
  background-color: ${({ theme, $processingStatus }) =>
    theme.palette.background[
      colorByProcessingStatus[$processingStatus].background
    ]};
  padding: 0.5rem;
  border-radius: 8px 8px 0px 0px;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.border.tertiary}`};
`;

const ProcessingTopBarLeftSide = styled(Box)`
  display: flex;
  gap: 8px;
  align-items: center;
`;
